<mc-drawer #drawer [opened]="isDrawerOpened" drawerWidth="470px" [notificationDrawer]="true">
  <ng-template #headerTemplate>
    <div class="notification-header-wrap">
      <mc-drawer-title>Notifications</mc-drawer-title>
      <button (click)="readAllNotifications()" class="read-all-notifications">Mark all as read</button>
    </div>
  </ng-template>
  <div class="notif-sidebar-container">
    <div class="scroll-section">
      <ul role="list" aria-label="Notifications" class="notification-section">
        @if (announcements.length) {
          <div>
            <div class="notification-section__title">Announcements</div>
            @for (item of announcements; track item.id) {
              <li class="notification-section__item">
                <mc-notification-item severity="primary" (read)="readNotification($event, item)">
                  <span content [innerHTML]="item.htmlContent"></span>
                </mc-notification-item>
              </li>
            }
          </div>
        }
        @for (item of personalNotifications; track item.id) {
          <li role="listitem" class="notification-section__item">
            <mc-notification-item
              [status]="item.status"
              [severity]="NotificationsService.getSeverity(item, userInfoQuery.trialInfo())"
              (read)="readNotification($event, item)"
            >
              <span
                content
                [innerHTML]="NotificationsService.getBaseTextNotification(item, userInfoQuery.trialInfo())"
              ></span>
              @if (item.type === notificationType.AccountBillingAlertsPaymentFailed) {
                <mc-notification-link
                  (linkClick)="close()"
                  [link]="'settings/billing-invoices'"
                  content="Please update your payment method."
                ></mc-notification-link>
              }
              @if (
                item.type === notificationType.AccountBillingAlertsPaymentMethodExpires &&
                NotificationsService.getNumberOfDaysToExpire(item) < 1
              ) {
                <mc-notification-link
                  (linkClick)="close()"
                  [link]="'settings/billing-invoices'"
                  content="Update your payment information to avoid any service disruptions."
                ></mc-notification-link>
              }
              <span>{{ NotificationsService.getDetailsTextNotification(item) }}</span>
              @if (
                item.type === notificationType.AccountBillingAlertsPaymentMethodExpires &&
                NotificationsService.getNumberOfDaysToExpire(item) >= 1
              ) {
                <mc-notification-link
                  (linkClick)="close()"
                  [link]="'settings/billing-invoices'"
                  content="Please update your payment method."
                ></mc-notification-link>
              }
            </mc-notification-item>
          </li>
        }
      </ul>
    </div>
  </div>
</mc-drawer>
